export default __webpack_public_path__ + "static/media/feature-strategic-2.8253fcf8.png";